module.exports = __webpack_public_path__ + "static/background_v3-bec082ab451bc6466808d1cbe47fb741.mp4";